module.exports = __webpack_public_path__ + "static/media/logo_glo.0f894142.svg";